<template>
    <div class='easteregg' :class='{ active: isActive }' id='teddybear' v-bind:style='mystyle' @click='activate'>
        <div class='easteregg-inner'>
        <video id='eastereggvideo' src="../assets/easteregg.webm"></video>
        </div>
    </div>
</template>

<script>


export default {
    name: 'teddy-bear',
    data() {
        return {
            top: '2000px',
            left: '-100px',
            rotate: 0,
            isActive: false,
        }
    },
    watch: {
        '$route': function() {

        }
    },
    computed: {
        mystyle() {
            return {
                top: this.top, 
                left: this.left,
                display: this.display,
                transform: `rotate(${this.rotate}deg)`
            };
        },
    },
    methods: {
        activate() {
            this.isActive = !this.isActive;
            let vid = document.getElementById('eastereggvideo');

            if (this.isActive) {
                vid.play();
            } else {
                vid.currentTime = 0;
            }
        },
        refresh() {
            this.$nextTick(()=>{
                let tiles = document.getElementsByClassName('resourceTile');
                
                let item = Math.floor(Math.random() * tiles.length);
                this.top = (tiles[item].offsetTop -45) + 'px';
                this.left = tiles[item].offsetLeft + 'px';
                this.display = 'block';
                this.rotate = Math.floor(Math.random() * 30) -15;
            });
        }
    },
    created() {
        this.$eventBus.$on('resources-loaded', this.refresh);
    },
    beforeDestroy() {
        this.$eventBus.$off('resources-loaded');
    }
}
</script>

<style lang='less'>
@keyframes shake {
  0% { transform:   rotate(0deg); }
  20% { transform:  rotate(-5deg); }
  40% { transform: rotate(5deg); }
  60% { transform:  rotate(-5deg); }
  80% { transform:  rotate(5deg); }
  100% { transform:  rotate(0deg); }
}


.easteregg {
    position: absolute;

    top: 350px;
    left: 300px;
    transition: all 0.5s;
    width: 100px;
    height: 100px;

    &.active {
        z-index: 1;
        width: 256px;
        height: 256px;
    }

    .eastereg-inner:hover {
        animation: shake 0.5s;
    }

    #eastereggvideo {
        outline: none;
        max-width: 100%;
    }
}
</style>